import React from 'react';
import {
  Flex,
  Spacer,
  Box,
  Divider,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
} from '@chakra-ui/react';
import { faIcons } from '@molecules/BEIcon/icons';
import BEIcon from '@molecules/BEIcon';
import { BEIconNameType } from '@molecules/BEIcon/BEIconProps';

const DemoIcon = () => {
  return (
    <Box>
      <h2>Icon</h2>
      <Divider m={2} />
      <Flex align={'center'}>
        <p></p>
        <Spacer />
        <Box>
          <Table>
            <Thead>
              <Tr>
                <Th>name</Th>
                <Th>light</Th>
                <Th>regular</Th>
                <Th>solid</Th>
              </Tr>
            </Thead>
            <Tbody>
              {Object.keys(faIcons).map((icon) => (
                <Tr key={icon}>
                  <Td>{icon}</Td>
                  <Td>
                    <BEIcon
                      size="lg"
                      name={icon as BEIconNameType}
                      weight="light"
                    />
                  </Td>
                  <Td>
                    <BEIcon
                      size="lg"
                      name={icon as BEIconNameType}
                      weight="regular"
                    />
                  </Td>
                  <Td>
                    <BEIcon
                      size="lg"
                      name={icon as BEIconNameType}
                      weight="solid"
                    />
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
        </Box>
      </Flex>
    </Box>
  );
};

export default DemoIcon;
